document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.mobile-menu');
  if (menu) {
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => menu.removeAttribute('open'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') menu.removeAttribute('open');
    });
  }

  const updatePageLock = () => {
    const modalIsOpen = document.querySelector(
      '.beauty-popup.is-open, .app-download-popup.is-open'
    );
    document.body.classList.toggle('site-modal-open', Boolean(modalIsOpen));
  };

  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const setupModal = ({ modal, dialogSelector, openerSelector, onClose }) => {
    if (!modal) return null;

    const dialog = modal.querySelector(dialogSelector);
    const closeButtons = modal.querySelectorAll(
      '[data-modal-close], [data-beauty-popup-close], [data-app-popup-close]'
    );
    let previousFocus = null;
    let closeTimer = null;

    // Only elements a person can actually see and reach by keyboard.
    const getFocusable = () =>
      [...modal.querySelectorAll(focusableSelector)].filter(
        (el) => el.tabIndex !== -1 && el.getClientRects().length > 0
      );

    const closeModal = () => {
      if (modal.hidden) return;
      window.clearTimeout(closeTimer);
      modal.classList.remove('is-open');
      if (onClose) onClose();
      updatePageLock();

      closeTimer = window.setTimeout(() => {
        modal.hidden = true;
        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus();
        }
      }, 240);
    };

    const openModal = (event) => {
      if (event) event.preventDefault();
      window.clearTimeout(closeTimer);
      previousFocus = document.activeElement;
      modal.hidden = false;

      window.requestAnimationFrame(() => {
        modal.classList.add('is-open');
        updatePageLock();
        if (dialog) dialog.focus();
      });
    };

    closeButtons.forEach((button) => button.addEventListener('click', closeModal));
    if (openerSelector) {
      document.querySelectorAll(openerSelector).forEach((opener) => {
        opener.addEventListener('click', openModal);
      });
    }

    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') closeModal();

      if (event.key === 'Tab') {
        const focusable = getFocusable();
        if (!focusable.length) {
          event.preventDefault();
          if (dialog) dialog.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;
        const inside = modal.contains(active);

        // Keep Tab and Shift+Tab inside the popup, including when the popup box itself has focus.
        if (event.shiftKey && (active === first || active === dialog || !inside)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (active === last || !inside)) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    // If focus ever lands on the page behind an open popup, bring it back.
    document.addEventListener('focusin', (event) => {
      if (modal.hidden || !modal.classList.contains('is-open')) return;
      if (modal.contains(event.target)) return;
      if (document.querySelectorAll('.beauty-popup.is-open, .app-download-popup.is-open').length > 1) return;

      const focusable = getFocusable();
      const target = focusable[0] || dialog;
      if (target) target.focus();
    });

    return { open: openModal, close: closeModal };
  };

  const beautyPopup = document.querySelector('[data-beauty-popup]');
  if (beautyPopup) {
    const storageKey = 'nail-garden-danella-seoul-glow-popup-dismissed-v8';
    const repeatAfter = 3 * 24 * 60 * 60 * 1000;

    const rememberDismissal = () => {
      try {
        window.localStorage.setItem(storageKey, String(Date.now()));
      } catch (_error) {
        // The popup still works when browser storage is unavailable.
      }
    };

    const beautyModal = setupModal({
      modal: beautyPopup,
      dialogSelector: '.beauty-popup__dialog',
      onClose: rememberDismissal
    });

    let shouldOpen = true;
    try {
      const dismissedAt = Number(window.localStorage.getItem(storageKey) || 0);
      shouldOpen = !dismissedAt || Date.now() - dismissedAt > repeatAfter;
    } catch (_error) {
      shouldOpen = true;
    }

    if (window.Shopify && window.Shopify.designMode) shouldOpen = true;
    if (shouldOpen && beautyModal) {
      const showBeautyPopup = () => {
        if (!document.querySelector('.app-download-popup.is-open')) beautyModal.open();
      };

      if (window.Shopify && window.Shopify.designMode) {
        window.setTimeout(showBeautyPopup, 1200);
      } else {
        // Phones get a longer pause so the hero and booking buttons are seen first.
        const isPhone = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
        window.addEventListener('load', () => {
          window.setTimeout(showBeautyPopup, isPhone ? 10000 : 6000);
        }, { once: true });
      }
    }

    const shopLink = beautyPopup.querySelector('[data-beauty-popup-shop]');
    if (shopLink && beautyModal) shopLink.addEventListener('click', beautyModal.close);
  }

  const appPopup = document.querySelector('[data-app-popup]');
  const appModal = setupModal({
    modal: appPopup,
    dialogSelector: '.app-download-popup__dialog',
    openerSelector: '[data-app-popup-open]'
  });

  if (appPopup && appModal) {
    appPopup.querySelectorAll('.app-store-choice').forEach((link) => {
      link.addEventListener('click', appModal.close);
    });
  }
});
